import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { joinThemeTable } from 'modules/think-seeds/actions';
import { fetchUserChats } from 'modules/chats';
import { setCanDrag, setGoDown } from 'routes/MainPage/modules/mainPage';
import CreationThinkSeed from '../components/CreationThinkSeed';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.creationThinkSeed,
    actualContext: state.steps.context,
    app: state.app,
    narratives: state.narratives.list,
    userConnections: state.userConnections.connections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    joinThemeTable: bindActionCreators(joinThemeTable, dispatch),
    setCanDrag: bindActionCreators(setCanDrag, dispatch),
    setGoDown: bindActionCreators(setGoDown, dispatch),
    getChats: bindActionCreators(fetchUserChats, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreationThinkSeed));



// WEBPACK FOOTER //
// ./src/components/CreationThinkSeed/container/index.js